import React, { FC, useEffect, useState } from "react";
import { Checkbox } from "semantic-ui-react";
import { config } from "../../contexts/UrlContext";
import { IGrid, IGridField } from "../Interfaces/TableInterface";

interface IProps {
    item: IGridField,
    onSelectedCallback: any
}

const MetaListItem: FC<IProps> = ({ item, onSelectedCallback }) => {
    const [selected, setSelected] = useState<boolean>(false)

    useEffect(() => {
        setSelected(item.selected);
    }, [item]);

    const updateList = () => {
        item.selected = !selected;
        onSelectedCallback(item, !selected);
        setSelected(!selected);
    }

    return (
        <div className="metaitem">
            <Checkbox checked={selected} onChange={updateList} label={item.name} />
        </div>
    );
}

export default MetaListItem;